import {
    Avatar,
    Breadcrumb,
    Button,
    Col,
    Drawer,
    Dropdown,
    Empty,
    Form, FormInstance,
    Input,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Tag,
    TimePicker,
    Upload,
    notification
} from "antd";
import React from "react";
import { connect } from "react-redux";
import { NavLink, RouteComponentProps } from "react-router-dom";
import { RootStoreModel } from "../../../redux/reducers";
import {
    BasicStateForListModel
} from "../../models";

import {
    AndroidFilled,
    AppleFilled, DeleteOutlined,
    DownOutlined,
    PlusOutlined,
    UploadOutlined,
    createFromIconfontCN
} from '@ant-design/icons';
import dayjs from 'dayjs';
import {
    addLocalApp,
    updateLocalApp,
    deleteLocalApp,
    getLocalApp,
    getLocalAppList,
    updateMacAppGetInfo
} from "../../../axios/api.mac.management";

import { Translation } from "react-i18next";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";

import i18n from "@src/locales";
const {Column} =Table
const { SubMenu } = Menu;
const { Item } = Form;
const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2670925_pf3sykyocl.js', // 在 iconfont.cn 上生成
});
interface stateModel extends BasicStateForListModel {
    name: string,
    current: string,
    selectTemplate: string,
    isShowTable: boolean,
    search: string,
    isShowAddForm: boolean,
    selectRow: any,
    showRightBox: boolean
    selectDevices: any[],
    currentName: string,
    templateTabs: any[],
    dropdownVisible: any[],
    isModify: boolean,
    platform:string,
    selectAppId: string,
    appShowStatus: number,
    imageUrl: string,
    logoFileType: string,
    packageFileType: string,
}
interface propsModel extends RouteComponentProps<any, any, any> {
    tokenSuccess: boolean
}
const mapStatetoProps = (state: RootStoreModel) => ({
    tokenSuccess: state.userState.tokenSuccess
});

class MacLocalAppIndex extends React.Component<propsModel, stateModel> {
    formRef = React.createRef<FormInstance>();
    constructor(props: propsModel) {
        super(props);
        this.state = {
            name: "MacLocalAppIndex",
            current: "CustomScript",
            currentName: "",
            selectTemplate: "",
            isShowTable: true,
            pageIndex: 1,
            pageSize: 10,
            totalCount: 0,
            search: "",
            loading: false,
            data: [],
            columns: [],
            isShowAddForm: false,
            selectRow: {},
            showRightBox: false,
            selectDevices: [],
            templateTabs: [],
            dropdownVisible: [],
            isModify: false,
            platform: "",
            selectAppId: "",
            appShowStatus: 0,
            imageUrl: "",
            logoFileType: 'Upload',
            packageFileType: 'Upload'
        }
    }
    Init() {
        this.getList();
        console.log("statessss",this.props.history.location.state);
        if (this.props.history.location.state && Object.keys(this.props.history.location.state).length > 0) {
            this.operationClick({key: 'edit'}, this.props.history.location.state);
        }
    }
    componentDidMount() {
        if (this.props.tokenSuccess) {
            this.Init();
        }

    }
    componentDidUpdate(prevProps: propsModel) {
        if (this.props.tokenSuccess !== prevProps.tokenSuccess) {
            this.Init();
        }
    }

    getList(pageIndex = this.state.pageIndex,
        pageSize = this.state.pageSize) {
        var temArg = {
            pageIndex: pageIndex,
            pageSize: pageSize,
            search: this.state.search
        }
        getLocalAppList(temArg).then(
            (res) => {
                this.setState({
                    data: res.dataList,
                    pageSize: res.pageSize,
                    pageIndex: res.pageIndex,
                    loading: false,
                    totalCount: res.totalCount,
                    dropdownVisible: [],
                });
                res.dataList.forEach((item: any) => {
                    this.state.dropdownVisible.push({key: item.id, value: false});
                });
            })
    }

    onSearch = () => {
        this.getList();

    }
    addTemplateClick = () => {
        this.formRef.current?.validateFields().then(
        (res) => {
            const { name, status, description, logo, appPackage, packageName, versionCode, version, 
                executionFrequency, isSelfService,logoFileType, logoUrl,packageFileType, packageUrl } = res;
            this.setState({ loading: true });
            if (!this.state.isModify) {
                
            if(packageFileType == 'Upload'){
                if (!appPackage[0]?.response?.objectID) {
                    notification.error({ message: <Translation>{t => {return t("请先上传应用")}}</Translation> })
                    return;
                }
            }
            
            addLocalApp({
                name,
                description,
                executionFrequency : executionFrequency,
                isSelfService: isSelfService,
                logo: logo ? (logo[0]?.originFileObj) : "",
                appTempId: appPackage ? appPackage[0]?.response?.objectID : "",
                packageName, 
                versionCode, 
                version,
                logoFileType, 
                logoUrl,
                packageFileType, 
                packageUrl
            }).then(
                () => {
                    notification.success({ message: <Translation>{t => {return t("添加成功")}}</Translation> });
                    this.formRef.current?.resetFields();
                    this.getList(1);
                },
                () => { notification.error({message: <Translation>{t => {return t("添加失败")}}</Translation>}) }
            ).finally(() => {
                this.setState({ loading: false, isShowAddForm: false, isModify: false })
            })
            } else if (this.state.isModify) {
                updateLocalApp(this.state.selectAppId, {
                    name,
                    description,
                    executionFrequency : executionFrequency,
                    isSelfService: isSelfService,
                    logo: logo ? (logo[0]?.originFileObj) : "",
                    appTempId: appPackage ? appPackage[0]?.response?.objectID : "",
                    packageName, 
                    versionCode, 
                    version,
                    logoFileType, 
                    logoUrl,
                    packageFileType, 
                    packageUrl
                }).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("更新成功")}}</Translation> });
                        this.getList(1);
                        this.formRef.current?.resetFields();
                    },
                    () => { notification.error({message: <Translation>{t => {return t("更新失败")}}</Translation>}) }
                ).finally(() => {
                    this.setState({ loading: false, isShowAddForm: false, isModify: false })
                })
            }
        });
    };

    operationClick = (e: any, row: any) => {
        if (!e.key) {
            return
        }
        switch (e.key) {
            case "delete":
                deleteLocalApp(row.id).then(
                    () => {
                        notification.success({ message: <Translation>{t => {return t("删除成功")}}</Translation> });
                        this.getList();
                    }, 
                    () => { notification.error({ message: <Translation>{t => {return t("删除失败")}}</Translation> }) }
                )
                break;
            case "modify":
                this.setState({
                    isModify: true, 
                    isShowAddForm: true,
                    appShowStatus: 1,
                    imageUrl: row.logo,
                    selectAppId:row.id,
                    logoFileType: row.logoFileType,
                    packageFileType: row.packageFileType,
                });
                this.formRef.current?.setFieldsValue({
                    name: row.name,
                    logoUrl: row.logo,
                    description: row.description,
                    packageName: row.packageName,
                    versionCode: row.versionCode,
                    version: row.version,
                    executionFrequency: row.executionFrequency,
                    isSelfService: row.isSelfService,
                    logoFileType: row.logoFileType,
                    packageFileType: row.packageFileType,
                    packageUrl: row.appPackageUrl
                });

                break;
            case "devices":
                this.props.history.push({
                    pathname: `/home/mac/localApp/devices/${row.id}`, 
                    state: row
                });
                break;
        
            default:
                break;
        }
    }
    onClose = () => {
        this.setState({
            showRightBox: false,
        });
    };
    getTemplateTab = () => {
        var tab = this.state.templateTabs.find(c => {
            return c.tabKey === this.state.current;
        })
        return tab;

    }

    normFile = (e: any) => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      };

      getBase64(img: any, callback: any) {
        const reader = new FileReader();
        reader.addEventListener("load", () => {
          callback(reader.result);
          console.log(reader);
        });
        reader.readAsDataURL(img);
      }

      beforeUpload = (file: File) => {
        const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        if (!isJpgOrPng) {
          notification.error({ message: <Translation>{t => {return t("You can only upload JPG/PNG file!")}}</Translation> });
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          notification.error({ message: <Translation>{t => {return t("Image must smaller than 2MB!")}}</Translation> });
        }
        // return isJpgOrPng && isLt2M;
        return false;
      };

      doImgUpload = (options: any) => {
        const { file } = options;
        if (file.name.endsWith(".pkg") || file.name.endsWith(".dmg")) {
          updateMacAppGetInfo(
            { AppPackage: file }, 
            (ev:any) => {
              const percent = ((ev.loaded / ev.total) * 100) | 0;
              options.onProgress({ percent: percent }, file);
            }
          ).then(
            (c: any) => {
              options.onSuccess({objectID: c.id, name: file.name}, file);
              var res = this.formRef.current?.getFieldsValue();
              res.packageName = c.packageName;
              res.version = c.version;
              res.versionCode = c.versionCode;
              this.formRef.current?.setFieldsValue(res);
            }, 
            () => {
              notification.error({ message: <Translation>{t => {return t("上传失败")}}</Translation> })
            }
          )
        }
      };
    
      handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
        this.getBase64(info.file, (imageUrl: any) => {
          this.setState({
            imageUrl: imageUrl,
            loading: false
          })
        });
      };
    
      handleChangeApk = (info: UploadChangeParam<UploadFile<any>>) => {
        //console.log(info)
      };

    render() {
        const { 
            isShowTable, appShowStatus,imageUrl,
            data, pageIndex, pageSize, totalCount, search, 
            loading, isShowAddForm, 
            currentName, dropdownVisible, isModify,logoFileType,packageFileType
            } = this.state;
        return (
            (<Translation>{t => {
                    return (
                        (<div>
                            <div className="breadcrumbTop py-2">
                                <Breadcrumb>
                                   
                                    <Breadcrumb.Item>{t("Mac端管")}</Breadcrumb.Item>
                                    <Breadcrumb.Item>  
                                        <a onClick={() => {
                                            this.setState({ 
                                                isShowTable: true
                                            });
                                            this.props.history.replace("/home/mac/localApp/index");
                                        }}>{t("本地应用")}</a>
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                                {!currentName && (
                                    <Row style={{padding: "32px 0 11px 0"}}>
                                        <Space>
                                            <img src="/images/profileIcon.svg" alt="" />
                                            <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("本地应用")}</span>
                                        </Space>
                                    </Row>
                                )}
                            </div>
                            <Row style={{ width: "100%" }}>
                                {isShowTable && (
                                    <>
                                        <div className="borderBox">
                                            <Row  className="mb-3">
                                                <Col > 
                                                {t("应用名称")}:
                                                <Input placeholder="" value={search}
                                                style={{ width: "200px", marginLeft: 10 }}
                                                    onChange={(e) => this.setState({ search: e.target.value })} /></Col>
                                                <Col offset={1}>
                                                    <Button type="primary" onClick={() => { this.onSearch(); }}>
                                                        {t("查询")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="borderBox">
                                            <Row>
                                                <Col className="ms-auto" style={{ marginBottom: 8 }}>  <Button type="primary"
                                                    onClick={() => { this.setState({ isShowAddForm: true, isModify: false, appShowStatus: 0, imageUrl: "" }) }}><PlusOutlined />{t("添加")} {t("应用")}</Button></Col>
                                            </Row>
                                            <Row  >
                                                <Col span={24}>
                                                    <Table 
                                                        size="middle" 
                                                        dataSource={data} 
                                                        rowKey={recored => recored.id} 
                                                        style={{ width: "100%", minHeight: 300 }} 
                                                        pagination={false}
                                                        locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                                                    >
                                                        <Column
                                                            title={""}
                                                            key="logo"
                                                            dataIndex="logo"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <Avatar
                                                                        shape="square"
                                                                        size={68}
                                                                        src={v}
                                                                        alt=""
                                                                    />
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("应用名称")}
                                                            key="name"
                                                            dataIndex="name"
                                                        ></Column>
                                                        <Column
                                                            title={t("包名")}
                                                            key="packageName"
                                                            dataIndex="packageName"
                                                        ></Column>
                                                        <Column
                                                            title={t("版本")}
                                                            key="version"
                                                            dataIndex="version"
                                                        ></Column>
                                                        <Column
                                                            title={t("关联设备")}
                                                            key="deviceCount"
                                                            dataIndex="deviceCount"
                                                            align="center"
                                                            render={(v, row: any, index) => {
                                                                return (
                                                                    <NavLink to={{ pathname: `/home/mac/localApp/devices/${row.id}`, state: row }} >{v}</NavLink>
                                                                )
                                                            }}
                                                        ></Column>
                                                        <Column
                                                            title={t("操作")}
                                                            key="id"
                                                            dataIndex="id"
                                                            align="center"
                                                            render={(v, row : any, index) => {
                                                                return (
                                                                    <Dropdown
                                                                        open={dropdownVisible.length > 0 && dropdownVisible[index]['value']}
                                                                        onOpenChange={(visible) => {
                                                                            const tempList: any[] = [];
                                                                            dropdownVisible.forEach((item) => {
                                                                                if (item.key === v) {
                                                                                    item['value'] = visible;
                                                                                }
                                                                                tempList.push(item);
                                                                            })
                                                                            this.setState({dropdownVisible: tempList});
                                                                        }}
                                                                        // trigger={['click']}
                                                                        dropdownRender={() => (
                                                                            <Menu onClick={(res) => this.operationClick(res, row)}>
                                                                                <Menu.Item key='modify'>{t("更新应用")}</Menu.Item>
                                                                                <Popconfirm title={"确认删除?"} onConfirm={() => this.operationClick({key: 'delete'}, row)}>
                                                                                    <Menu.Item key='delete' className="custom-menu-item">{t("删除")}</Menu.Item>
                                                                                </Popconfirm>
                                                                            </Menu>
                                                                        )}>
                                                                        <a>{t("更多")}<DownOutlined /></a>
                                                                    </Dropdown>
                                                                )
                                                            }}></Column>
                                                    </Table>
                                                    <Pagination
                                                        style={{ textAlign: "right", marginTop: "20px" }}
                                                        pageSize={pageSize}
                                                        current={pageIndex}
                                                        total={totalCount}
                                                        showTotal={(total, range) =>
                                                            `${range[0]}-${range[1]} / ${total} ${t("条")}`
                                                        }
                                                        onChange={(page, pageSize) => {
                                                            this.getList(page, pageSize);
                                                        }}
                                                        onShowSizeChange={(current, size) => this.getList(current, size)}
                                                    ></Pagination>
                                                </Col>
                                            </Row>
                                            <Modal
                                                confirmLoading={loading}
                                                maskClosable={false}
                                                open={isShowAddForm}
                                                destroyOnClose={true}
                                                //title={`${isModify ? "" : t("添加")} ${t("命令策略")}`}
                                                title={ !isModify ? t("添加应用") : t("更新应用")}
                                                forceRender={true}
                                                width={"650px"}
                                                onOk={() => { this.addTemplateClick() }}
                                                onCancel={() => {
                                                    this.setState({ 
                                                        isShowAddForm: false,
                                                        isModify: false, 
                                                        loading: false
                                                    });
                                                    this.formRef.current?.resetFields();
                                                }}
                                                okText={t("确认")}
                                                cancelText={t("取消")}
                                            >
                                                <Spin spinning={loading}>
                                                    <Form
                                                        layout="horizontal"
                                                        ref={this.formRef}
                                                        labelCol={{ span: i18n.language === "zh" ? 4 : 6 }}
                                                        initialValues={{ name: "", executionFrequency: "No",
                                                            packageName: "", description:"",
                                                            isSelfService: true, logoFileType:'Upload',
                                                            packageFileType: 'Upload'
                                                        }}
                                                    >
                                                    <Item label={t("执行策略")} name="executionFrequency" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value="No">{t("不执行")}</Select.Option>
                                                            <Select.Option value="Once">{t("一次")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={t("自助服务")} name="isSelfService" rules={[{ required: true }]}>
                                                        <Select>
                                                            <Select.Option value={true}>{t("是")}</Select.Option>
                                                            <Select.Option value={false}>{t("否")}</Select.Option>
                                                        </Select>
                                                    </Item>
                                                    <Item label={<span>&nbsp;</span>} name="packageFileType" colon={false}>
                                                        <Radio.Group onChange={(e)=>{this.setState({packageFileType: e.target.value})}}>
                                                            <Radio value="Upload">上传文件</Radio>
                                                            <Radio value="Url">文件链接</Radio>
                                                        </Radio.Group>
                                                        </Item>
                                                        { packageFileType == 'Upload' && 
                                                         <Item
                                                            label={t("应用文件")}
                                                            name="appPackage"
                                                            rules={[{ required: appShowStatus == 0 }]}
                                                            valuePropName="fileList"
                                                            getValueFromEvent={this.normFile}
                                                            extra={t("支持pkg、dmg格式，文件不大于1000MB")}
                                                        >
                                                            <Upload
                                                            accept=".pkg,.dmg"
                                                            customRequest={this.doImgUpload}
                                                            listType="text"
                                                            showUploadList={true}
                                                            onChange={this.handleChangeApk}
                                                            maxCount={1}
                                                            >
                                                            <Button icon={<UploadOutlined />}>+ {t("点击上传")} </Button>
                                                            </Upload>
                                                        </Item>
                                                        }
                                                        { packageFileType == 'Url' && 
                                                            <Item
                                                            label={t("文件链接")}
                                                            name="packageUrl"
                                                            rules={[{ required: true }]}
                                                            >
                                                            <Input></Input>
                                                            </Item>
                                                        }

                                                    <Item label={t("包名")} name="packageName" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item
                                                        label={t("版本号")}
                                                        name="version"
                                                        rules={[{ required: true }]}
                                                    >
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("应用名称")} name="name" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    <Item label={t("简介")} name="description" rules={[{ required: true }]}>
                                                        <Input></Input>
                                                    </Item>
                                                    {/* <Item name="logoUrl" style={{ display: "none" }}>
                                                        <Input></Input>
                                                    </Item> */}
                                                    <Item label={<span>&nbsp;</span>} name="logoFileType" colon={false}>
                                                        <Radio.Group onChange={(e)=>{this.setState({logoFileType: e.target.value})}}>
                                                            <Radio value="Upload">上传文件</Radio>
                                                            <Radio value="Url">文件链接</Radio>
                                                        </Radio.Group>
                                                    </Item>
                                                    { logoFileType == 'Upload' && 
                                                    <Item
                                                        label={t("应用图标")}
                                                        name="logo"
                                                        rules={[{ required: appShowStatus == 0 }]}
                                                        valuePropName="fileList"
                                                        getValueFromEvent={this.normFile}
                                                        extra={t("不大于1MB,尺寸512px*512px")}
                                                    >
                                                        <Upload
                                                            maxCount={1}
                                                            listType="picture-card"
                                                            accept="jpg,.png"
                                                            showUploadList={false}
                                                            beforeUpload={this.beforeUpload}
                                                            onChange={this.handleChange}
                                                            >
                                                            {imageUrl ? (
                                                                <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
                                                            ) : (
                                                                "+"
                                                            )}
                                                        </Upload>

                                                    </Item>
                                                    }
                                                    { logoFileType == 'Url' && 
                                                        <Item
                                                        label={t("Logo链接")}
                                                        name="logoUrl"
                                                        rules={[{ required: true }]}
                                                        >
                                                            <Input></Input>
                                                        </Item>
                                                    }
                                                    </Form>
                                                </Spin>
                                                {/* <LocalAppForm
                                                    status={isModify ? 1 : 0} onLoad={(ref) => {
                                                    this.setState({ appFormRef: ref })
                                                    if(appShowStatus == 1)
                                                        ref.setFieldsValue(this.state.selectData);
                                                }}
                                                ></LocalAppForm> */}
                                            </Modal>
                                        </div>
                                    </>
                                )}
                            </Row>
                        </div>)
                    );
                }}</Translation>)
        );
    }
}
export default connect(mapStatetoProps, {})(MacLocalAppIndex);